import { isDevEnv } from '@config/environment'
import { Suspense } from 'react'
import { Loading } from 'shared-ui/components'
import { DebugProvider, LogLevel } from 'shared-ui/debug'
import { BrowserLocalizationProvider, i18nInit } from 'shared-ui/localization'
import { subscribeToUrlSync } from 'shared-ui/map'

import { ApiWrapper } from './ApiWrapper'

i18nInit()
subscribeToUrlSync()

const logLevel = isDevEnv() ? LogLevel.Debug : LogLevel.Disabled

const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <DebugProvider logLevelThreshold={logLevel}>
    <Suspense fallback={<Loading />}>
      <BrowserLocalizationProvider>
        <ApiWrapper>
          <Suspense fallback={<Loading />}>{children}</Suspense>
        </ApiWrapper>
      </BrowserLocalizationProvider>
    </Suspense>
  </DebugProvider>
)

export default AppProvider
